module.exports = __webpack_public_path__ + "media/bootstrap-icons/align-start-c86420a8.svg";